import React, { useState } from 'react';
import classNames from 'classnames';
import { connect } from "react-redux";
import { Modal  } from 'antd';
import Button from "components/button";
import { 
	doPayrollProgressUpdate
} from "../../../../redux/payroll/payrollState";

function PayrollProcessButton({doPayrollProcess, payrollId, process, children, confirmationMessage, className, ...rest}) {
	
	const buttonClassName = classNames('me-3 z-50 crud-button btn-primary',className);
	const [open, setOpen] = useState(false);
	
	const processHandler = () => {		
		doPayrollProcess({payrollId, process});
        setOpen(false);
	};
	
    return (<>
    	<Button className={buttonClassName.trim()} 
    		{...rest}
    		onClick={(e) => {e.preventDefault();setOpen(true)}}
		>
  			{children}
		</Button> 
		<Modal
            className={{content: 'popup-message'}}
            open={open}
            closeIcon={false}
            centered
            title={<h2 className="popup-modal-title">Confirm Action</h2>}
            okText="Confirm"
            cancelText="Cancel"
            footer={(_) => (
                <>
                    <Button className="me-4 btn-primary" 
                        onClick={() => {setOpen(false)}}
                    >
                        Cancel
                    </Button>
                    <Button className="btn-primary" 
                        onClick={processHandler}
                    >
                        Confirm
                    </Button>
                </>
            )}
        >
            <div className='content-wrapper'>
                {confirmationMessage && <div>{confirmationMessage}</div>}            
                <div>Are you sure you want to continue?</div>
            </div>
        </Modal>
    </>);
}

const mapStateToProps = () => ({
  
});

const mapDispatchToProps = (dispatch) => ({
  doPayrollProcess: (parameters) => dispatch(doPayrollProgressUpdate(parameters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PayrollProcessButton);



